import { RequestKind, string } from '@sb/library/base';
import { ApiRoute } from '../api-route';

export namespace PaymentRoutes {
    export const Get = ApiRoute.Define({
        URL: `payments/url`,
        Kind: RequestKind.Get,
        ResultType: string
    });
}
